import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import * as contactActions from './contactActions';
import * as moduleActions from '../moduleActions';


class Contact extends Component {
    constructor(props) {
      super(props);
      // State is in reducers
      this.state = {
        allowFilterType:true,
        inactiveType : [],
        moduleName:"CONTACT",
        icon:"address-card",
        //updateNumber:0,
      };

    }

    componentDidMount = () =>{
      // CREATE MODULE DATA IN STATE MODULE OBJECT
      this.props.registerModule(this.state.moduleName);
      document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    
    handleClickOutside = (event) => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
          //this.props.toggleExpand("");
        }
    }
    

    buildModuleBlock = () => {
      var inactiveType = this.state.inactiveType;
      var contentList = <div className="placeHolder-list">
                          <span>No Contact to display</span>
                        </div>;

      return(
        <div className="moduleBlock">
          {contentList}
        </div>
      )
    }
  
  
    render() {
      var moduleBlock = this.buildModuleBlock();
      var moduleFilter = null;
      var alert = false;

      return (
        <div   className={this.props.extendedModule === this.state.moduleName?"header-column extended":"header-column"}  >
          <FontAwesomeIcon icon={this.state.icon} onClick={this.props.toggleExpand.bind(this,this.state.moduleName)}/> 
          {alert? <div className="alert"></div>:null}
          <div className="extendBlocks" onMouseOut={this.hideBlocks}>
          <div className="extendBlocksHeader"><div className="headerTitle">{this.state.moduleName} pannel</div>{moduleFilter}</div>
            {moduleBlock}
          </div>
        </div>
      );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {  
      notificationHistory: state.appReducer.notificationHistory,
      extendedModule: state.appReducer.extendedModule,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      registerModule: (type) =>dispatch(moduleActions.registerModule(type)),
      toggleExpand: (type) => dispatch(moduleActions.toggleExpand(type)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(Contact);
